import pluralize from 'pluralize-ru';
export type Value = string | number;

const pluralizeHours = (value: Value) =>
  pluralize(value, '%d часов', '%d час', '%d часа', '%d часов');
const pluralizeMinutes = (value: Value) =>
  pluralize(value, '%d минут', '%d минута', '%d минуты', '%d минут');
const pluralizeSeconds = (value: Value) =>
  pluralize(value, '%d секунд', '%d секунда', '%d секунды', '%d секунд');
const pluralizeRuble = (value: Value) =>
  pluralize(value, '%d рублей', '%d рубль', '%d рубля', '%d рублей');
const pluralizeQuestion = (value: Value) =>
  pluralize(value, '%d вопросов', '%d вопроса', '%d вопросов', '%d вопросов');
const pluralizeAttempt = (value: Value) =>
  pluralize(value, '%d попытка', '%d попытка', '%d попытки', '%d попыток');
const hoursOrRuble = (type: string, value: Value) => {
  if (type === 'HOURS') return pluralizeHours(value);
  if (type === 'RUB') return pluralizeRuble(value);
  return;
};
const pluralizePeople = (value: Value) =>
  pluralize(value, '%d человек', '%d человек', '%d человека', '%d человек');
const pluralizeProgramm = (value: Value) =>
  pluralize(
    value,
    '%d программ',
    '%d программа',
    '%d программы',
    '%d программ',
  );
const pluralizeСompetences = (value: Value) =>
  pluralize(
    value,
    '%d компетенций',
    '%d компетенция',
    '%d компетенции',
    '%d компетенций',
  );
const pluralizeLecture = (value: Value) =>
  pluralize(value, '%d лекций', '%d лекция', '%d лекции', '%d лекций');
const pluralizeLesson = (value: Value) =>
  pluralize(value, '%d занятий', '%d занятие', '%d занятия', '%d занятий');
const pluralizeToPeople = (value: Value) =>
  pluralize(value, '%d человек', '%d человека', '%d человек', '%d человек');
const pluralizeAge = (value: Value) =>
  pluralize(value, '%d лет', '%d год', '%d года', '%d лет');
const pluralizeWeeks = (value: Value) =>
  pluralize(value, '%d недель', '%d неделя', '%d недели', '%d недель');
const pluralizeMembers = (value: Value) =>
  pluralize(
    value,
    '%d участников',
    '%d участник',
    '%d участника',
    '%d участников',
  );

export {
  pluralizeHours,
  pluralizeMinutes,
  pluralizeSeconds,
  pluralizeRuble,
  pluralizeQuestion,
  pluralizeAttempt,
  hoursOrRuble,
  pluralizePeople,
  pluralizeToPeople,
  pluralizeAge,
  pluralizeMembers,
  pluralizeWeeks,
  pluralizeLecture,
  pluralizeLesson,
  pluralizeProgramm,
  pluralizeСompetences,
};



// WEBPACK FOOTER //
// ./src/tools/pluralize.ts